import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { StandaloneSelectField } from 'components/FormElements/FormSelectField';
import React, { useEffect, useRef, useState } from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { BarLoader } from 'react-spinners';
import { APINetworkCall, callAPI } from '../../../../../utils/network/index';
import { PrepAreaTooltip } from '../../MenuEditor/components/shared/TooltipModals';
import './index.scss';

export const AddPrinterDialog = ({
  locked,
  fullScreen,
  open,
  onClose,
  onPrinterAdded,
  showAlert,
  venueId,
}) => {
  const [printerName, setPrinterName] = useState('');
  const [prepArea, setPrepArea] = useState('');
  const [creatingPrinter, setCreatingPrinter] = useState(false);
  const [newPrinterId, setNewPrinterId] = useState('');
  const [currentStep, setCurrentStep] = useState(1);

  const nameElement = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (nameElement.current) {
        nameElement.current.focus();
      }
    }, 100);
  }, []);

  const createNewPrinter = async () => {
    if (prepArea === '') {
      showAlert(
        'Invalid Prep Area',
        'You must select a Prep Area. Please use the dropdown.'
      );
      return;
    }

    setCreatingPrinter(true);

    const body = { printer_name: printerName, prep_area: prepArea };
    const apiRequest = APINetworkCall.fromURL(
      `${process.env.REACT_APP_API_URL}/print/create-printer`,
      body,
      'POST'
    );

    try {
      const { printer_id: newPrinterID } = await callAPI(apiRequest);
      setNewPrinterId(newPrinterID);
      setCurrentStep(currentStep + 1);
    } catch (e) {
      console.error(e);
      showAlert(
        'Failure',
        'Sorry, we could not create the Print Device. Please try again later.'
      );
    }

    setCreatingPrinter(false);
  };

  const printerUrl = `${process.env.REACT_APP_API_URL}/print/connect/${newPrinterId}`;

  return (
    <Dialog
      className="dialog__add__printer"
      disableBackdropClick={locked}
      disableEscapeKeyDown={locked}
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="add-printer"
    >
      <DialogTitle
        className="dialog__add__printer__title"
        id="responsive-dialog-title"
      >
        Add a Printer
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="centered__dialog__content__text">
          Fatsoma Tabb supports these Star printer series:
          <br />
          mC-Print2, mC-Print3, TSP654III and SP742.
        </DialogContentText>

        <p className="step__descriptor">Step {currentStep} of 2</p>

        <div className="printer__details">
          {!newPrinterId && currentStep === 1 && (
            <React.Fragment>
              <TextField
                fullWidth={true}
                label="Printer Name"
                inputRef={nameElement}
                autoFocus={true}
                onChange={evt => setPrinterName(evt.target.value)}
                value={printerName}
                className="settings__section__details__form__name printer__name"
                type="text"
                hinttext="Printer Name"
                placeholder="e.g. Front of House"
                margin="normal"
              />

              <StandaloneSelectField
                label={
                  <span>
                    Prep Area <PrepAreaTooltip />
                  </span>
                }
                autoFocus={true}
                displayEmpty
                value={prepArea}
                onChange={evt => setPrepArea(evt.target.value)}
              >
                <MenuItem value="" disabled>
                  Select Prep Area
                </MenuItem>
                <MenuItem value="general">Front of House</MenuItem>
                <MenuItem value="kitchen">Kitchen</MenuItem>
              </StandaloneSelectField>
            </React.Fragment>
          )}

          {newPrinterId && currentStep === 2 && (
            <React.Fragment>
              <p class="settings__section__update__title">
                <b>Update your printer's CloudPRNT settings</b>
              </p>
              <p>
                Copy and paste the URL below into the Server URL field inside
                your printer's CloudPRNT settings page
              </p>
              <div className="settings__section__preview__url">
                {printerUrl}
              </div>

              <p class="settings__section__need__help">
                Need help?{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://intercom.help/tabb/en/articles/5188075-how-to-set-up-connect-your-printer"
                >
                  See our step-by-step guide
                </a>
              </p>
            </React.Fragment>
          )}
        </div>

        <div className="dialog__button__row">
          <Button
            className="fatsoma__cta__secondary"
            disabled={creatingPrinter}
            onClick={() => onClose()}
            color="primary"
          >
            Close
          </Button>
          {currentStep === 1 && (
            <Button
              disabled={creatingPrinter}
              className="fatsoma__cta"
              onClick={() => {
                if (currentStep === 1) {
                  createNewPrinter();
                }
              }}
            >
              {!creatingPrinter && 'Next'}
              {creatingPrinter && <BarLoader color="#fff" height={4} />}
            </Button>
          )}
          {newPrinterId && currentStep === 2 && (
            <Button
              className="fatsoma__cta"
              onClick={() => onPrinterAdded()}
              autoFocus
            >
              I'm done!
            </Button>
          )}
        </div>
      </DialogContent>

      <Loader text="Creating Printer" loading={creatingPrinter} />
    </Dialog>
  );
};

export default withMobileDialog()(AddPrinterDialog);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Settings/AddPrinterDialog/index.jsx